/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Rush Hour Real Estate Platform API
 * MVP платформы недвижимости - публичные эндпоинты
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  AdminAuthLogout200,
  AdminAuthResponse,
  AdminListLeadsParams,
  AdminMicrosoftLoginRequest,
  AdminRemoveTeamMember200,
  AdminTeamMemberRequest,
  AdminTeamMemberUpdateRequest,
  AdminUpdateTeamMember200,
  AdminUser,
  Area,
  AreaCreateRequest,
  AreaUpdateRequest,
  Badge,
  BadgeCreateRequest,
  BadgeUpdateRequest,
  City,
  CityCreateRequest,
  CityUpdateRequest,
  Developer,
  DeveloperCreateRequest,
  DeveloperUpdateRequest,
  FilterOptions,
  ForbiddenResponse,
  GetProjectParams,
  Infrastructure,
  InfrastructureCreateRequest,
  InfrastructureUpdateRequest,
  InternalErrorResponse,
  Lead,
  LeadCreateRequest,
  LeadUpdateRequest,
  ListAreasParams,
  ListLotsParams,
  ListProjectsParams,
  Lot,
  LotCreateRequest,
  LotUpdateRequest,
  LotsListResponse,
  NotFoundResponse,
  Project,
  ProjectCreateRequest,
  ProjectUpdateRequest,
  UnauthorizedResponse,
  ValidationErrorResponse,
} from '../schemas'

import { adminInstance } from '../../adminMutator'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Получить список районов
 */
export const listAreas = (
  params?: ListAreasParams,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Area[]>({ url: `/areas`, method: 'GET', params, signal }, options)
}

export const getListAreasQueryKey = (params?: ListAreasParams) => {
  return [`/areas`, ...(params ? [params] : [])] as const
}

export const getListAreasQueryOptions = <
  TData = Awaited<ReturnType<typeof listAreas>>,
  TError = InternalErrorResponse,
>(
  params?: ListAreasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAreas>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAreasQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAreas>>> = ({ signal }) =>
    listAreas(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAreas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAreasQueryResult = NonNullable<Awaited<ReturnType<typeof listAreas>>>
export type ListAreasQueryError = InternalErrorResponse

export function useListAreas<
  TData = Awaited<ReturnType<typeof listAreas>>,
  TError = InternalErrorResponse,
>(
  params: undefined | ListAreasParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAreas>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAreas>>,
          TError,
          Awaited<ReturnType<typeof listAreas>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAreas<
  TData = Awaited<ReturnType<typeof listAreas>>,
  TError = InternalErrorResponse,
>(
  params?: ListAreasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAreas>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAreas>>,
          TError,
          Awaited<ReturnType<typeof listAreas>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAreas<
  TData = Awaited<ReturnType<typeof listAreas>>,
  TError = InternalErrorResponse,
>(
  params?: ListAreasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAreas>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список районов
 */

export function useListAreas<
  TData = Awaited<ReturnType<typeof listAreas>>,
  TError = InternalErrorResponse,
>(
  params?: ListAreasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAreas>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAreasQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить район по slug
 */
export const getArea = (
  slug: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Area>({ url: `/areas/${slug}`, method: 'GET', signal }, options)
}

export const getGetAreaQueryKey = (slug?: string) => {
  return [`/areas/${slug}`] as const
}

export const getGetAreaQueryOptions = <
  TData = Awaited<ReturnType<typeof getArea>>,
  TError = NotFoundResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getArea>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAreaQueryKey(slug)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getArea>>> = ({ signal }) =>
    getArea(slug, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getArea>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAreaQueryResult = NonNullable<Awaited<ReturnType<typeof getArea>>>
export type GetAreaQueryError = NotFoundResponse

export function useGetArea<TData = Awaited<ReturnType<typeof getArea>>, TError = NotFoundResponse>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getArea>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArea>>,
          TError,
          Awaited<ReturnType<typeof getArea>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArea<TData = Awaited<ReturnType<typeof getArea>>, TError = NotFoundResponse>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getArea>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArea>>,
          TError,
          Awaited<ReturnType<typeof getArea>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArea<TData = Awaited<ReturnType<typeof getArea>>, TError = NotFoundResponse>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getArea>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить район по slug
 */

export function useGetArea<TData = Awaited<ReturnType<typeof getArea>>, TError = NotFoundResponse>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getArea>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAreaQueryOptions(slug, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить список городов
 */
export const listCities = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<City[]>({ url: `/cities`, method: 'GET', signal }, options)
}

export const getListCitiesQueryKey = () => {
  return [`/cities`] as const
}

export const getListCitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCities>>,
  TError = InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCities>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListCitiesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCities>>> = ({ signal }) =>
    listCities(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listCities>>>
export type ListCitiesQueryError = InternalErrorResponse

export function useListCities<
  TData = Awaited<ReturnType<typeof listCities>>,
  TError = InternalErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCities>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCities>>,
          TError,
          Awaited<ReturnType<typeof listCities>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCities<
  TData = Awaited<ReturnType<typeof listCities>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCities>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCities>>,
          TError,
          Awaited<ReturnType<typeof listCities>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCities<
  TData = Awaited<ReturnType<typeof listCities>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCities>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список городов
 */

export function useListCities<
  TData = Awaited<ReturnType<typeof listCities>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCities>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить опции фильтров
 */
export const getFilterOptions = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<FilterOptions>({ url: `/filters/options`, method: 'GET', signal }, options)
}

export const getGetFilterOptionsQueryKey = () => {
  return [`/filters/options`] as const
}

export const getGetFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFilterOptions>>,
  TError = InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFilterOptionsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilterOptions>>> = ({ signal }) =>
    getFilterOptions(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFilterOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getFilterOptions>>>
export type GetFilterOptionsQueryError = InternalErrorResponse

export function useGetFilterOptions<
  TData = Awaited<ReturnType<typeof getFilterOptions>>,
  TError = InternalErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getFilterOptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilterOptions<
  TData = Awaited<ReturnType<typeof getFilterOptions>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getFilterOptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilterOptions<
  TData = Awaited<ReturnType<typeof getFilterOptions>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить опции фильтров
 */

export function useGetFilterOptions<
  TData = Awaited<ReturnType<typeof getFilterOptions>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить список проектов
 */
export const listProjects = (
  params?: ListProjectsParams,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Project[]>({ url: `/projects`, method: 'GET', params, signal }, options)
}

export const getListProjectsQueryKey = (params?: ListProjectsParams) => {
  return [`/projects`, ...(params ? [params] : [])] as const
}

export const getListProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = InternalErrorResponse,
>(
  params?: ListProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListProjectsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) =>
    listProjects(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsQueryError = InternalErrorResponse

export function useListProjects<
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = InternalErrorResponse,
>(
  params: undefined | ListProjectsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjects>>,
          TError,
          Awaited<ReturnType<typeof listProjects>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjects<
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = InternalErrorResponse,
>(
  params?: ListProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjects>>,
          TError,
          Awaited<ReturnType<typeof listProjects>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjects<
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = InternalErrorResponse,
>(
  params?: ListProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список проектов
 */

export function useListProjects<
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = InternalErrorResponse,
>(
  params?: ListProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListProjectsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить проект по slug
 */
export const getProject = (
  slug: string,
  params?: GetProjectParams,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Project>(
    { url: `/projects/${slug}`, method: 'GET', params, signal },
    options
  )
}

export const getGetProjectQueryKey = (slug?: string, params?: GetProjectParams) => {
  return [`/projects/${slug}`, ...(params ? [params] : [])] as const
}

export const getGetProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = NotFoundResponse,
>(
  slug: string,
  params?: GetProjectParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProjectQueryKey(slug, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) =>
    getProject(slug, params, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = NotFoundResponse

export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = NotFoundResponse,
>(
  slug: string,
  params: undefined | GetProjectParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = NotFoundResponse,
>(
  slug: string,
  params?: GetProjectParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = NotFoundResponse,
>(
  slug: string,
  params?: GetProjectParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить проект по slug
 */

export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = NotFoundResponse,
>(
  slug: string,
  params?: GetProjectParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectQueryOptions(slug, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить список лотов (каталог)
 */
export const listLots = (
  params?: ListLotsParams,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<LotsListResponse>({ url: `/lots`, method: 'GET', params, signal }, options)
}

export const getListLotsQueryKey = (params?: ListLotsParams) => {
  return [`/lots`, ...(params ? [params] : [])] as const
}

export const getListLotsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLots>>,
  TError = InternalErrorResponse,
>(
  params?: ListLotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLots>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListLotsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLots>>> = ({ signal }) =>
    listLots(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLotsQueryResult = NonNullable<Awaited<ReturnType<typeof listLots>>>
export type ListLotsQueryError = InternalErrorResponse

export function useListLots<
  TData = Awaited<ReturnType<typeof listLots>>,
  TError = InternalErrorResponse,
>(
  params: undefined | ListLotsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLots>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLots>>,
          TError,
          Awaited<ReturnType<typeof listLots>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLots<
  TData = Awaited<ReturnType<typeof listLots>>,
  TError = InternalErrorResponse,
>(
  params?: ListLotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLots>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLots>>,
          TError,
          Awaited<ReturnType<typeof listLots>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLots<
  TData = Awaited<ReturnType<typeof listLots>>,
  TError = InternalErrorResponse,
>(
  params?: ListLotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLots>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список лотов (каталог)
 */

export function useListLots<
  TData = Awaited<ReturnType<typeof listLots>>,
  TError = InternalErrorResponse,
>(
  params?: ListLotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLots>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListLotsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить лот по ID
 */
export const getLot = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Lot>({ url: `/lots/${id}`, method: 'GET', signal }, options)
}

export const getGetLotQueryKey = (id?: string) => {
  return [`/lots/${id}`] as const
}

export const getGetLotQueryOptions = <
  TData = Awaited<ReturnType<typeof getLot>>,
  TError = NotFoundResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLot>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetLotQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLot>>> = ({ signal }) =>
    getLot(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLotQueryResult = NonNullable<Awaited<ReturnType<typeof getLot>>>
export type GetLotQueryError = NotFoundResponse

export function useGetLot<TData = Awaited<ReturnType<typeof getLot>>, TError = NotFoundResponse>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLot>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLot>>,
          TError,
          Awaited<ReturnType<typeof getLot>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLot<TData = Awaited<ReturnType<typeof getLot>>, TError = NotFoundResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLot>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLot>>,
          TError,
          Awaited<ReturnType<typeof getLot>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLot<TData = Awaited<ReturnType<typeof getLot>>, TError = NotFoundResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLot>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить лот по ID
 */

export function useGetLot<TData = Awaited<ReturnType<typeof getLot>>, TError = NotFoundResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLot>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLotQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Создать заявку (lead)
 */
export const createLead = (
  leadCreateRequest: LeadCreateRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Lead>(
    {
      url: `/leads`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: leadCreateRequest,
      signal,
    },
    options
  )
}

export const getCreateLeadMutationOptions = <
  TError = ValidationErrorResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLead>>,
    TError,
    { data: LeadCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLead>>,
  TError,
  { data: LeadCreateRequest },
  TContext
> => {
  const mutationKey = ['createLead']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLead>>,
    { data: LeadCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return createLead(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof createLead>>>
export type CreateLeadMutationBody = LeadCreateRequest
export type CreateLeadMutationError = ValidationErrorResponse | InternalErrorResponse

/**
 * @summary Создать заявку (lead)
 */
export const useCreateLead = <
  TError = ValidationErrorResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLead>>,
      TError,
      { data: LeadCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLead>>,
  TError,
  { data: LeadCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateLeadMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список застройщиков
 */
export const listDevelopers = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Developer[]>({ url: `/developers`, method: 'GET', signal }, options)
}

export const getListDevelopersQueryKey = () => {
  return [`/developers`] as const
}

export const getListDevelopersQueryOptions = <
  TData = Awaited<ReturnType<typeof listDevelopers>>,
  TError = InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevelopers>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListDevelopersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDevelopers>>> = ({ signal }) =>
    listDevelopers(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDevelopers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDevelopersQueryResult = NonNullable<Awaited<ReturnType<typeof listDevelopers>>>
export type ListDevelopersQueryError = InternalErrorResponse

export function useListDevelopers<
  TData = Awaited<ReturnType<typeof listDevelopers>>,
  TError = InternalErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevelopers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDevelopers>>,
          TError,
          Awaited<ReturnType<typeof listDevelopers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDevelopers<
  TData = Awaited<ReturnType<typeof listDevelopers>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevelopers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDevelopers>>,
          TError,
          Awaited<ReturnType<typeof listDevelopers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDevelopers<
  TData = Awaited<ReturnType<typeof listDevelopers>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevelopers>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список застройщиков
 */

export function useListDevelopers<
  TData = Awaited<ReturnType<typeof listDevelopers>>,
  TError = InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevelopers>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListDevelopersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить список застройщиков (админ)
 */
export const adminListDevelopers = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Developer[]>({ url: `/admin/developers`, method: 'GET', signal }, options)
}

export const getAdminListDevelopersQueryKey = () => {
  return [`/admin/developers`] as const
}

export const getAdminListDevelopersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListDevelopers>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListDevelopersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDevelopers>>> = ({ signal }) =>
    adminListDevelopers(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDevelopers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListDevelopersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDevelopers>>
>
export type AdminListDevelopersQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListDevelopers<
  TData = Awaited<ReturnType<typeof adminListDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDevelopers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDevelopers>>,
          TError,
          Awaited<ReturnType<typeof adminListDevelopers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDevelopers<
  TData = Awaited<ReturnType<typeof adminListDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDevelopers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDevelopers>>,
          TError,
          Awaited<ReturnType<typeof adminListDevelopers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDevelopers<
  TData = Awaited<ReturnType<typeof adminListDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListDevelopers>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список застройщиков (админ)
 */

export function useAdminListDevelopers<
  TData = Awaited<ReturnType<typeof adminListDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListDevelopers>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListDevelopersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Создать застройщика (админ)
 */
export const adminCreateDeveloper = (
  developerCreateRequest: DeveloperCreateRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Developer>(
    {
      url: `/admin/developers`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: developerCreateRequest,
      signal,
    },
    options
  )
}

export const getAdminCreateDeveloperMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateDeveloper>>,
    TError,
    { data: DeveloperCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateDeveloper>>,
  TError,
  { data: DeveloperCreateRequest },
  TContext
> => {
  const mutationKey = ['adminCreateDeveloper']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateDeveloper>>,
    { data: DeveloperCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return adminCreateDeveloper(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminCreateDeveloperMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateDeveloper>>
>
export type AdminCreateDeveloperMutationBody = DeveloperCreateRequest
export type AdminCreateDeveloperMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | InternalErrorResponse

/**
 * @summary Создать застройщика (админ)
 */
export const useAdminCreateDeveloper = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateDeveloper>>,
      TError,
      { data: DeveloperCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateDeveloper>>,
  TError,
  { data: DeveloperCreateRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateDeveloperMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить застройщика по ID (админ)
 */
export const adminGetDeveloper = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Developer>(
    { url: `/admin/developers/${id}`, method: 'GET', signal },
    options
  )
}

export const getAdminGetDeveloperQueryKey = (id?: string) => {
  return [`/admin/developers/${id}`] as const
}

export const getAdminGetDeveloperQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetDeveloper>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetDeveloper>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetDeveloperQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetDeveloper>>> = ({ signal }) =>
    adminGetDeveloper(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetDeveloper>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetDeveloperQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetDeveloper>>
>
export type AdminGetDeveloperQueryError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

export function useAdminGetDeveloper<
  TData = Awaited<ReturnType<typeof adminGetDeveloper>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetDeveloper>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetDeveloper>>,
          TError,
          Awaited<ReturnType<typeof adminGetDeveloper>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetDeveloper<
  TData = Awaited<ReturnType<typeof adminGetDeveloper>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetDeveloper>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetDeveloper>>,
          TError,
          Awaited<ReturnType<typeof adminGetDeveloper>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetDeveloper<
  TData = Awaited<ReturnType<typeof adminGetDeveloper>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetDeveloper>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить застройщика по ID (админ)
 */

export function useAdminGetDeveloper<
  TData = Awaited<ReturnType<typeof adminGetDeveloper>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetDeveloper>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetDeveloperQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Мягкое удаление застройщика (установка deleted_at)
 */
export const adminSoftDeleteDeveloper = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/developers/${id}`, method: 'DELETE' }, options)
}

export const getAdminSoftDeleteDeveloperMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSoftDeleteDeveloper>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSoftDeleteDeveloper>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSoftDeleteDeveloper']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSoftDeleteDeveloper>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminSoftDeleteDeveloper(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminSoftDeleteDeveloperMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSoftDeleteDeveloper>>
>

export type AdminSoftDeleteDeveloperMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Мягкое удаление застройщика (установка deleted_at)
 */
export const useAdminSoftDeleteDeveloper = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSoftDeleteDeveloper>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSoftDeleteDeveloper>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminSoftDeleteDeveloperMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Обновить застройщика (админ)
 */
export const adminUpdateDeveloper = (
  id: string,
  developerUpdateRequest: DeveloperUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<Developer>(
    {
      url: `/admin/developers/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: developerUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateDeveloperMutationOptions = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateDeveloper>>,
    TError,
    { id: string; data: DeveloperUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateDeveloper>>,
  TError,
  { id: string; data: DeveloperUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateDeveloper']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateDeveloper>>,
    { id: string; data: DeveloperUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateDeveloper(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateDeveloperMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateDeveloper>>
>
export type AdminUpdateDeveloperMutationBody = DeveloperUpdateRequest
export type AdminUpdateDeveloperMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Обновить застройщика (админ)
 */
export const useAdminUpdateDeveloper = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateDeveloper>>,
      TError,
      { id: string; data: DeveloperUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateDeveloper>>,
  TError,
  { id: string; data: DeveloperUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateDeveloperMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список удаленных застройщиков (админ)
 */
export const adminListDeletedDevelopers = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Developer[]>(
    { url: `/admin/developers/deleted`, method: 'GET', signal },
    options
  )
}

export const getAdminListDeletedDevelopersQueryKey = () => {
  return [`/admin/developers/deleted`] as const
}

export const getAdminListDeletedDevelopersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDeletedDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedDevelopers>>, TError, TData>
  >
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListDeletedDevelopersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDeletedDevelopers>>> = ({
    signal,
  }) => adminListDeletedDevelopers(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDeletedDevelopers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListDeletedDevelopersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDeletedDevelopers>>
>
export type AdminListDeletedDevelopersQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListDeletedDevelopers<
  TData = Awaited<ReturnType<typeof adminListDeletedDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedDevelopers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedDevelopers>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedDevelopers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedDevelopers<
  TData = Awaited<ReturnType<typeof adminListDeletedDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedDevelopers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedDevelopers>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedDevelopers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedDevelopers<
  TData = Awaited<ReturnType<typeof adminListDeletedDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedDevelopers>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список удаленных застройщиков (админ)
 */

export function useAdminListDeletedDevelopers<
  TData = Awaited<ReturnType<typeof adminListDeletedDevelopers>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedDevelopers>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListDeletedDevelopersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Восстановить удаленного застройщика (админ)
 */
export const adminRestoreDeveloper = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Developer>(
    { url: `/admin/developers/${id}/restore`, method: 'POST', signal },
    options
  )
}

export const getAdminRestoreDeveloperMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreDeveloper>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRestoreDeveloper>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRestoreDeveloper']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRestoreDeveloper>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminRestoreDeveloper(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRestoreDeveloperMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRestoreDeveloper>>
>

export type AdminRestoreDeveloperMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Восстановить удаленного застройщика (админ)
 */
export const useAdminRestoreDeveloper = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRestoreDeveloper>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminRestoreDeveloper>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminRestoreDeveloperMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Полное удаление застройщика (админ)
 */
export const adminHardDeleteDeveloper = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>(
    { url: `/admin/developers/${id}/hard-delete`, method: 'DELETE' },
    options
  )
}

export const getAdminHardDeleteDeveloperMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteDeveloper>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminHardDeleteDeveloper>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminHardDeleteDeveloper']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminHardDeleteDeveloper>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminHardDeleteDeveloper(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminHardDeleteDeveloperMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminHardDeleteDeveloper>>
>

export type AdminHardDeleteDeveloperMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Полное удаление застройщика (админ)
 */
export const useAdminHardDeleteDeveloper = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminHardDeleteDeveloper>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminHardDeleteDeveloper>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminHardDeleteDeveloperMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список районов (админ)
 */
export const adminListAreas = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Area[]>({ url: `/admin/areas`, method: 'GET', signal }, options)
}

export const getAdminListAreasQueryKey = () => {
  return [`/admin/areas`] as const
}

export const getAdminListAreasQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAreas>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListAreasQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListAreas>>> = ({ signal }) =>
    adminListAreas(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListAreas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListAreasQueryResult = NonNullable<Awaited<ReturnType<typeof adminListAreas>>>
export type AdminListAreasQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListAreas<
  TData = Awaited<ReturnType<typeof adminListAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAreas>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListAreas>>,
          TError,
          Awaited<ReturnType<typeof adminListAreas>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListAreas<
  TData = Awaited<ReturnType<typeof adminListAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAreas>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListAreas>>,
          TError,
          Awaited<ReturnType<typeof adminListAreas>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListAreas<
  TData = Awaited<ReturnType<typeof adminListAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAreas>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список районов (админ)
 */

export function useAdminListAreas<
  TData = Awaited<ReturnType<typeof adminListAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAreas>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListAreasQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Создать район (админ)
 */
export const adminCreateArea = (
  areaCreateRequest: AreaCreateRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Area>(
    {
      url: `/admin/areas`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: areaCreateRequest,
      signal,
    },
    options
  )
}

export const getAdminCreateAreaMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateArea>>,
    TError,
    { data: AreaCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateArea>>,
  TError,
  { data: AreaCreateRequest },
  TContext
> => {
  const mutationKey = ['adminCreateArea']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateArea>>,
    { data: AreaCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return adminCreateArea(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminCreateAreaMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateArea>>>
export type AdminCreateAreaMutationBody = AreaCreateRequest
export type AdminCreateAreaMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | InternalErrorResponse

/**
 * @summary Создать район (админ)
 */
export const useAdminCreateArea = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateArea>>,
      TError,
      { data: AreaCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateArea>>,
  TError,
  { data: AreaCreateRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateAreaMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить район по ID (админ)
 */
export const adminGetArea = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Area>({ url: `/admin/areas/${id}`, method: 'GET', signal }, options)
}

export const getAdminGetAreaQueryKey = (id?: string) => {
  return [`/admin/areas/${id}`] as const
}

export const getAdminGetAreaQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetArea>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetArea>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetAreaQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetArea>>> = ({ signal }) =>
    adminGetArea(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetArea>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetAreaQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetArea>>>
export type AdminGetAreaQueryError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse

export function useAdminGetArea<
  TData = Awaited<ReturnType<typeof adminGetArea>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetArea>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetArea>>,
          TError,
          Awaited<ReturnType<typeof adminGetArea>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetArea<
  TData = Awaited<ReturnType<typeof adminGetArea>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetArea>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetArea>>,
          TError,
          Awaited<ReturnType<typeof adminGetArea>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetArea<
  TData = Awaited<ReturnType<typeof adminGetArea>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetArea>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить район по ID (админ)
 */

export function useAdminGetArea<
  TData = Awaited<ReturnType<typeof adminGetArea>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetArea>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetAreaQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Мягкое удаление района (установка deleted_at)
 */
export const adminSoftDeleteArea = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/areas/${id}`, method: 'DELETE' }, options)
}

export const getAdminSoftDeleteAreaMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSoftDeleteArea>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSoftDeleteArea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSoftDeleteArea']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSoftDeleteArea>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminSoftDeleteArea(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminSoftDeleteAreaMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSoftDeleteArea>>
>

export type AdminSoftDeleteAreaMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Мягкое удаление района (установка deleted_at)
 */
export const useAdminSoftDeleteArea = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSoftDeleteArea>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSoftDeleteArea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminSoftDeleteAreaMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Обновить район (админ)
 */
export const adminUpdateArea = (
  id: string,
  areaUpdateRequest: AreaUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<Area>(
    {
      url: `/admin/areas/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: areaUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateAreaMutationOptions = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateArea>>,
    TError,
    { id: string; data: AreaUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateArea>>,
  TError,
  { id: string; data: AreaUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateArea']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateArea>>,
    { id: string; data: AreaUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateArea(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateAreaMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateArea>>>
export type AdminUpdateAreaMutationBody = AreaUpdateRequest
export type AdminUpdateAreaMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Обновить район (админ)
 */
export const useAdminUpdateArea = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateArea>>,
      TError,
      { id: string; data: AreaUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateArea>>,
  TError,
  { id: string; data: AreaUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateAreaMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список удаленных районов (админ)
 */
export const adminListDeletedAreas = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Area[]>({ url: `/admin/areas/deleted`, method: 'GET', signal }, options)
}

export const getAdminListDeletedAreasQueryKey = () => {
  return [`/admin/areas/deleted`] as const
}

export const getAdminListDeletedAreasQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDeletedAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedAreas>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListDeletedAreasQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDeletedAreas>>> = ({ signal }) =>
    adminListDeletedAreas(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDeletedAreas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListDeletedAreasQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDeletedAreas>>
>
export type AdminListDeletedAreasQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListDeletedAreas<
  TData = Awaited<ReturnType<typeof adminListDeletedAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedAreas>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedAreas>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedAreas>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedAreas<
  TData = Awaited<ReturnType<typeof adminListDeletedAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedAreas>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedAreas>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedAreas>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedAreas<
  TData = Awaited<ReturnType<typeof adminListDeletedAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedAreas>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список удаленных районов (админ)
 */

export function useAdminListDeletedAreas<
  TData = Awaited<ReturnType<typeof adminListDeletedAreas>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedAreas>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListDeletedAreasQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Восстановить удаленный район (админ)
 */
export const adminRestoreArea = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Area>({ url: `/admin/areas/${id}/restore`, method: 'POST', signal }, options)
}

export const getAdminRestoreAreaMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreArea>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRestoreArea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRestoreArea']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRestoreArea>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminRestoreArea(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRestoreAreaMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRestoreArea>>
>

export type AdminRestoreAreaMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Восстановить удаленный район (админ)
 */
export const useAdminRestoreArea = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRestoreArea>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminRestoreArea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminRestoreAreaMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Полное удаление района (админ)
 */
export const adminHardDeleteArea = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/areas/${id}/hard-delete`, method: 'DELETE' }, options)
}

export const getAdminHardDeleteAreaMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteArea>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminHardDeleteArea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminHardDeleteArea']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminHardDeleteArea>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminHardDeleteArea(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminHardDeleteAreaMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminHardDeleteArea>>
>

export type AdminHardDeleteAreaMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Полное удаление района (админ)
 */
export const useAdminHardDeleteArea = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminHardDeleteArea>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminHardDeleteArea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminHardDeleteAreaMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список городов (админ)
 */
export const adminListCities = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<City[]>({ url: `/admin/cities`, method: 'GET', signal }, options)
}

export const getAdminListCitiesQueryKey = () => {
  return [`/admin/cities`] as const
}

export const getAdminListCitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListCities>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListCitiesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListCities>>> = ({ signal }) =>
    adminListCities(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListCities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListCitiesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListCities>>>
export type AdminListCitiesQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListCities<
  TData = Awaited<ReturnType<typeof adminListCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListCities>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListCities>>,
          TError,
          Awaited<ReturnType<typeof adminListCities>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListCities<
  TData = Awaited<ReturnType<typeof adminListCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListCities>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListCities>>,
          TError,
          Awaited<ReturnType<typeof adminListCities>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListCities<
  TData = Awaited<ReturnType<typeof adminListCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListCities>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список городов (админ)
 */

export function useAdminListCities<
  TData = Awaited<ReturnType<typeof adminListCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListCities>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListCitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Создать город (админ)
 */
export const adminCreateCity = (
  cityCreateRequest: CityCreateRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<City>(
    {
      url: `/admin/cities`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cityCreateRequest,
      signal,
    },
    options
  )
}

export const getAdminCreateCityMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateCity>>,
    TError,
    { data: CityCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateCity>>,
  TError,
  { data: CityCreateRequest },
  TContext
> => {
  const mutationKey = ['adminCreateCity']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateCity>>,
    { data: CityCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return adminCreateCity(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminCreateCityMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateCity>>>
export type AdminCreateCityMutationBody = CityCreateRequest
export type AdminCreateCityMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | InternalErrorResponse

/**
 * @summary Создать город (админ)
 */
export const useAdminCreateCity = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateCity>>,
      TError,
      { data: CityCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateCity>>,
  TError,
  { data: CityCreateRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateCityMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить город по ID (админ)
 */
export const adminGetCity = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<City>({ url: `/admin/cities/${id}`, method: 'GET', signal }, options)
}

export const getAdminGetCityQueryKey = (id?: string) => {
  return [`/admin/cities/${id}`] as const
}

export const getAdminGetCityQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetCity>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCity>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetCityQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetCity>>> = ({ signal }) =>
    adminGetCity(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetCity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetCityQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetCity>>>
export type AdminGetCityQueryError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse

export function useAdminGetCity<
  TData = Awaited<ReturnType<typeof adminGetCity>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCity>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetCity>>,
          TError,
          Awaited<ReturnType<typeof adminGetCity>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetCity<
  TData = Awaited<ReturnType<typeof adminGetCity>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCity>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetCity>>,
          TError,
          Awaited<ReturnType<typeof adminGetCity>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetCity<
  TData = Awaited<ReturnType<typeof adminGetCity>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCity>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить город по ID (админ)
 */

export function useAdminGetCity<
  TData = Awaited<ReturnType<typeof adminGetCity>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCity>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetCityQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Мягкое удаление города (установка deleted_at)
 */
export const adminSoftDeleteCity = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/cities/${id}`, method: 'DELETE' }, options)
}

export const getAdminSoftDeleteCityMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSoftDeleteCity>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSoftDeleteCity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSoftDeleteCity']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSoftDeleteCity>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminSoftDeleteCity(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminSoftDeleteCityMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSoftDeleteCity>>
>

export type AdminSoftDeleteCityMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Мягкое удаление города (установка deleted_at)
 */
export const useAdminSoftDeleteCity = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSoftDeleteCity>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSoftDeleteCity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminSoftDeleteCityMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Обновить город (админ)
 */
export const adminUpdateCity = (
  id: string,
  cityUpdateRequest: CityUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<City>(
    {
      url: `/admin/cities/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: cityUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateCityMutationOptions = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateCity>>,
    TError,
    { id: string; data: CityUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateCity>>,
  TError,
  { id: string; data: CityUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateCity']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateCity>>,
    { id: string; data: CityUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateCity(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateCityMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateCity>>>
export type AdminUpdateCityMutationBody = CityUpdateRequest
export type AdminUpdateCityMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Обновить город (админ)
 */
export const useAdminUpdateCity = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateCity>>,
      TError,
      { id: string; data: CityUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateCity>>,
  TError,
  { id: string; data: CityUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateCityMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список удаленных городов (админ)
 */
export const adminListDeletedCities = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<City[]>({ url: `/admin/cities/deleted`, method: 'GET', signal }, options)
}

export const getAdminListDeletedCitiesQueryKey = () => {
  return [`/admin/cities/deleted`] as const
}

export const getAdminListDeletedCitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDeletedCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedCities>>, TError, TData>
  >
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListDeletedCitiesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDeletedCities>>> = ({ signal }) =>
    adminListDeletedCities(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDeletedCities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListDeletedCitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDeletedCities>>
>
export type AdminListDeletedCitiesQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListDeletedCities<
  TData = Awaited<ReturnType<typeof adminListDeletedCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedCities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedCities>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedCities>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedCities<
  TData = Awaited<ReturnType<typeof adminListDeletedCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedCities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedCities>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedCities>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedCities<
  TData = Awaited<ReturnType<typeof adminListDeletedCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedCities>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список удаленных городов (админ)
 */

export function useAdminListDeletedCities<
  TData = Awaited<ReturnType<typeof adminListDeletedCities>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedCities>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListDeletedCitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Восстановить удаленный город (админ)
 */
export const adminRestoreCity = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<City>(
    { url: `/admin/cities/${id}/restore`, method: 'POST', signal },
    options
  )
}

export const getAdminRestoreCityMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreCity>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRestoreCity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRestoreCity']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRestoreCity>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminRestoreCity(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRestoreCityMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRestoreCity>>
>

export type AdminRestoreCityMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Восстановить удаленный город (админ)
 */
export const useAdminRestoreCity = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRestoreCity>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminRestoreCity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminRestoreCityMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Полное удаление города (админ)
 */
export const adminHardDeleteCity = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/cities/${id}/hard-delete`, method: 'DELETE' }, options)
}

export const getAdminHardDeleteCityMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteCity>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminHardDeleteCity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminHardDeleteCity']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminHardDeleteCity>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminHardDeleteCity(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminHardDeleteCityMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminHardDeleteCity>>
>

export type AdminHardDeleteCityMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Полное удаление города (админ)
 */
export const useAdminHardDeleteCity = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminHardDeleteCity>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminHardDeleteCity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminHardDeleteCityMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список проектов (админ)
 */
export const adminListProjects = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Project[]>({ url: `/admin/projects`, method: 'GET', signal }, options)
}

export const getAdminListProjectsQueryKey = () => {
  return [`/admin/projects`] as const
}

export const getAdminListProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListProjects>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListProjectsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListProjects>>> = ({ signal }) =>
    adminListProjects(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListProjects>>
>
export type AdminListProjectsQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListProjects<
  TData = Awaited<ReturnType<typeof adminListProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListProjects>>,
          TError,
          Awaited<ReturnType<typeof adminListProjects>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListProjects<
  TData = Awaited<ReturnType<typeof adminListProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListProjects>>,
          TError,
          Awaited<ReturnType<typeof adminListProjects>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListProjects<
  TData = Awaited<ReturnType<typeof adminListProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListProjects>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список проектов (админ)
 */

export function useAdminListProjects<
  TData = Awaited<ReturnType<typeof adminListProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListProjects>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListProjectsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Создать проект (админ)
 */
export const adminCreateProject = (
  projectCreateRequest: ProjectCreateRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Project>(
    {
      url: `/admin/projects`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: projectCreateRequest,
      signal,
    },
    options
  )
}

export const getAdminCreateProjectMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateProject>>,
    TError,
    { data: ProjectCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateProject>>,
  TError,
  { data: ProjectCreateRequest },
  TContext
> => {
  const mutationKey = ['adminCreateProject']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateProject>>,
    { data: ProjectCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return adminCreateProject(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminCreateProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateProject>>
>
export type AdminCreateProjectMutationBody = ProjectCreateRequest
export type AdminCreateProjectMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | InternalErrorResponse

/**
 * @summary Создать проект (админ)
 */
export const useAdminCreateProject = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateProject>>,
      TError,
      { data: ProjectCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateProject>>,
  TError,
  { data: ProjectCreateRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateProjectMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить проект по ID (админ)
 */
export const adminGetProject = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Project>({ url: `/admin/projects/${id}`, method: 'GET', signal }, options)
}

export const getAdminGetProjectQueryKey = (id?: string) => {
  return [`/admin/projects/${id}`] as const
}

export const getAdminGetProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetProject>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProject>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetProjectQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetProject>>> = ({ signal }) =>
    adminGetProject(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetProject>>>
export type AdminGetProjectQueryError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

export function useAdminGetProject<
  TData = Awaited<ReturnType<typeof adminGetProject>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProject>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProject>>,
          TError,
          Awaited<ReturnType<typeof adminGetProject>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetProject<
  TData = Awaited<ReturnType<typeof adminGetProject>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProject>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProject>>,
          TError,
          Awaited<ReturnType<typeof adminGetProject>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetProject<
  TData = Awaited<ReturnType<typeof adminGetProject>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProject>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить проект по ID (админ)
 */

export function useAdminGetProject<
  TData = Awaited<ReturnType<typeof adminGetProject>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProject>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetProjectQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Мягкое удаление проекта (установка deleted_at)
 */
export const adminSoftDeleteProject = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/projects/${id}`, method: 'DELETE' }, options)
}

export const getAdminSoftDeleteProjectMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSoftDeleteProject>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSoftDeleteProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSoftDeleteProject']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSoftDeleteProject>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminSoftDeleteProject(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminSoftDeleteProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSoftDeleteProject>>
>

export type AdminSoftDeleteProjectMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Мягкое удаление проекта (установка deleted_at)
 */
export const useAdminSoftDeleteProject = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSoftDeleteProject>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSoftDeleteProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminSoftDeleteProjectMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Обновить проект (админ)
 */
export const adminUpdateProject = (
  id: string,
  projectUpdateRequest: ProjectUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<Project>(
    {
      url: `/admin/projects/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: projectUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateProjectMutationOptions = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateProject>>,
    TError,
    { id: string; data: ProjectUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateProject>>,
  TError,
  { id: string; data: ProjectUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateProject']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateProject>>,
    { id: string; data: ProjectUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateProject(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateProject>>
>
export type AdminUpdateProjectMutationBody = ProjectUpdateRequest
export type AdminUpdateProjectMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Обновить проект (админ)
 */
export const useAdminUpdateProject = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateProject>>,
      TError,
      { id: string; data: ProjectUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateProject>>,
  TError,
  { id: string; data: ProjectUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateProjectMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список удаленных проектов (админ)
 */
export const adminListDeletedProjects = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Project[]>(
    { url: `/admin/projects/deleted`, method: 'GET', signal },
    options
  )
}

export const getAdminListDeletedProjectsQueryKey = () => {
  return [`/admin/projects/deleted`] as const
}

export const getAdminListDeletedProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDeletedProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedProjects>>, TError, TData>
  >
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListDeletedProjectsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDeletedProjects>>> = ({
    signal,
  }) => adminListDeletedProjects(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDeletedProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListDeletedProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDeletedProjects>>
>
export type AdminListDeletedProjectsQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListDeletedProjects<
  TData = Awaited<ReturnType<typeof adminListDeletedProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedProjects>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedProjects>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedProjects>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedProjects<
  TData = Awaited<ReturnType<typeof adminListDeletedProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedProjects>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedProjects>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedProjects>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedProjects<
  TData = Awaited<ReturnType<typeof adminListDeletedProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedProjects>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список удаленных проектов (админ)
 */

export function useAdminListDeletedProjects<
  TData = Awaited<ReturnType<typeof adminListDeletedProjects>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedProjects>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListDeletedProjectsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Восстановить удаленный проект (админ)
 */
export const adminRestoreProject = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Project>(
    { url: `/admin/projects/${id}/restore`, method: 'POST', signal },
    options
  )
}

export const getAdminRestoreProjectMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreProject>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRestoreProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRestoreProject']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRestoreProject>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminRestoreProject(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRestoreProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRestoreProject>>
>

export type AdminRestoreProjectMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Восстановить удаленный проект (админ)
 */
export const useAdminRestoreProject = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRestoreProject>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminRestoreProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminRestoreProjectMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Полное удаление проекта (админ)
 */
export const adminHardDeleteProject = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>(
    { url: `/admin/projects/${id}/hard-delete`, method: 'DELETE' },
    options
  )
}

export const getAdminHardDeleteProjectMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteProject>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminHardDeleteProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminHardDeleteProject']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminHardDeleteProject>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminHardDeleteProject(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminHardDeleteProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminHardDeleteProject>>
>

export type AdminHardDeleteProjectMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Полное удаление проекта (админ)
 */
export const useAdminHardDeleteProject = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminHardDeleteProject>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminHardDeleteProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminHardDeleteProjectMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список лотов (админ)
 */
export const adminListLots = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<LotsListResponse>({ url: `/admin/lots`, method: 'GET', signal }, options)
}

export const getAdminListLotsQueryKey = () => {
  return [`/admin/lots`] as const
}

export const getAdminListLotsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLots>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListLotsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListLots>>> = ({ signal }) =>
    adminListLots(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListLots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListLotsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListLots>>>
export type AdminListLotsQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListLots<
  TData = Awaited<ReturnType<typeof adminListLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLots>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListLots>>,
          TError,
          Awaited<ReturnType<typeof adminListLots>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListLots<
  TData = Awaited<ReturnType<typeof adminListLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLots>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListLots>>,
          TError,
          Awaited<ReturnType<typeof adminListLots>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListLots<
  TData = Awaited<ReturnType<typeof adminListLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLots>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список лотов (админ)
 */

export function useAdminListLots<
  TData = Awaited<ReturnType<typeof adminListLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLots>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListLotsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Создать лот (админ)
 */
export const adminCreateLot = (
  lotCreateRequest: LotCreateRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Lot>(
    {
      url: `/admin/lots`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: lotCreateRequest,
      signal,
    },
    options
  )
}

export const getAdminCreateLotMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateLot>>,
    TError,
    { data: LotCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateLot>>,
  TError,
  { data: LotCreateRequest },
  TContext
> => {
  const mutationKey = ['adminCreateLot']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateLot>>,
    { data: LotCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return adminCreateLot(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminCreateLotMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateLot>>>
export type AdminCreateLotMutationBody = LotCreateRequest
export type AdminCreateLotMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | InternalErrorResponse

/**
 * @summary Создать лот (админ)
 */
export const useAdminCreateLot = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateLot>>,
      TError,
      { data: LotCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateLot>>,
  TError,
  { data: LotCreateRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateLotMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить лот по ID (админ)
 */
export const adminGetLot = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Lot>({ url: `/admin/lots/${id}`, method: 'GET', signal }, options)
}

export const getAdminGetLotQueryKey = (id?: string) => {
  return [`/admin/lots/${id}`] as const
}

export const getAdminGetLotQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetLot>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLot>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetLotQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetLot>>> = ({ signal }) =>
    adminGetLot(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetLotQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetLot>>>
export type AdminGetLotQueryError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse

export function useAdminGetLot<
  TData = Awaited<ReturnType<typeof adminGetLot>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLot>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLot>>,
          TError,
          Awaited<ReturnType<typeof adminGetLot>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetLot<
  TData = Awaited<ReturnType<typeof adminGetLot>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLot>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLot>>,
          TError,
          Awaited<ReturnType<typeof adminGetLot>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetLot<
  TData = Awaited<ReturnType<typeof adminGetLot>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLot>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить лот по ID (админ)
 */

export function useAdminGetLot<
  TData = Awaited<ReturnType<typeof adminGetLot>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLot>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetLotQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Мягкое удаление лота (установка deleted_at)
 */
export const adminSoftDeleteLot = (id: string, options?: SecondParameter<typeof adminInstance>) => {
  return adminInstance<void>({ url: `/admin/lots/${id}`, method: 'DELETE' }, options)
}

export const getAdminSoftDeleteLotMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSoftDeleteLot>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSoftDeleteLot>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSoftDeleteLot']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSoftDeleteLot>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminSoftDeleteLot(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminSoftDeleteLotMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSoftDeleteLot>>
>

export type AdminSoftDeleteLotMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Мягкое удаление лота (установка deleted_at)
 */
export const useAdminSoftDeleteLot = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSoftDeleteLot>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSoftDeleteLot>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminSoftDeleteLotMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Обновить лот (админ)
 */
export const adminUpdateLot = (
  id: string,
  lotUpdateRequest: LotUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<Lot>(
    {
      url: `/admin/lots/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: lotUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateLotMutationOptions = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateLot>>,
    TError,
    { id: string; data: LotUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateLot>>,
  TError,
  { id: string; data: LotUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateLot']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateLot>>,
    { id: string; data: LotUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateLot(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateLotMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateLot>>>
export type AdminUpdateLotMutationBody = LotUpdateRequest
export type AdminUpdateLotMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Обновить лот (админ)
 */
export const useAdminUpdateLot = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateLot>>,
      TError,
      { id: string; data: LotUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateLot>>,
  TError,
  { id: string; data: LotUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateLotMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список удаленных лотов (админ)
 */
export const adminListDeletedLots = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<LotsListResponse>(
    { url: `/admin/lots/deleted`, method: 'GET', signal },
    options
  )
}

export const getAdminListDeletedLotsQueryKey = () => {
  return [`/admin/lots/deleted`] as const
}

export const getAdminListDeletedLotsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDeletedLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedLots>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListDeletedLotsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDeletedLots>>> = ({ signal }) =>
    adminListDeletedLots(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDeletedLots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListDeletedLotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDeletedLots>>
>
export type AdminListDeletedLotsQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListDeletedLots<
  TData = Awaited<ReturnType<typeof adminListDeletedLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedLots>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedLots>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedLots>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedLots<
  TData = Awaited<ReturnType<typeof adminListDeletedLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedLots>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedLots>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedLots>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedLots<
  TData = Awaited<ReturnType<typeof adminListDeletedLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedLots>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список удаленных лотов (админ)
 */

export function useAdminListDeletedLots<
  TData = Awaited<ReturnType<typeof adminListDeletedLots>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedLots>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListDeletedLotsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Восстановить удаленный лот (админ)
 */
export const adminRestoreLot = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Lot>({ url: `/admin/lots/${id}/restore`, method: 'POST', signal }, options)
}

export const getAdminRestoreLotMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreLot>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRestoreLot>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRestoreLot']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRestoreLot>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminRestoreLot(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRestoreLotMutationResult = NonNullable<Awaited<ReturnType<typeof adminRestoreLot>>>

export type AdminRestoreLotMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Восстановить удаленный лот (админ)
 */
export const useAdminRestoreLot = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRestoreLot>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminRestoreLot>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminRestoreLotMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Полное удаление лота (админ)
 */
export const adminHardDeleteLot = (id: string, options?: SecondParameter<typeof adminInstance>) => {
  return adminInstance<void>({ url: `/admin/lots/${id}/hard-delete`, method: 'DELETE' }, options)
}

export const getAdminHardDeleteLotMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteLot>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminHardDeleteLot>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminHardDeleteLot']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminHardDeleteLot>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminHardDeleteLot(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminHardDeleteLotMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminHardDeleteLot>>
>

export type AdminHardDeleteLotMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Полное удаление лота (админ)
 */
export const useAdminHardDeleteLot = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminHardDeleteLot>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminHardDeleteLot>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminHardDeleteLotMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список заявок (админ)
 */
export const adminListLeads = (
  params?: AdminListLeadsParams,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Lead[]>({ url: `/admin/leads`, method: 'GET', params, signal }, options)
}

export const getAdminListLeadsQueryKey = (params?: AdminListLeadsParams) => {
  return [`/admin/leads`, ...(params ? [params] : [])] as const
}

export const getAdminListLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListLeads>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  params?: AdminListLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLeads>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListLeadsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListLeads>>> = ({ signal }) =>
    adminListLeads(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListLeads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListLeads>>>
export type AdminListLeadsQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListLeads<
  TData = Awaited<ReturnType<typeof adminListLeads>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  params: undefined | AdminListLeadsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLeads>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListLeads>>,
          TError,
          Awaited<ReturnType<typeof adminListLeads>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListLeads<
  TData = Awaited<ReturnType<typeof adminListLeads>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  params?: AdminListLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLeads>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListLeads>>,
          TError,
          Awaited<ReturnType<typeof adminListLeads>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListLeads<
  TData = Awaited<ReturnType<typeof adminListLeads>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  params?: AdminListLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLeads>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список заявок (админ)
 */

export function useAdminListLeads<
  TData = Awaited<ReturnType<typeof adminListLeads>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  params?: AdminListLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLeads>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListLeadsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Получить список бейджей (админ)
 */
export const adminListBadges = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Badge[]>({ url: `/admin/badges`, method: 'GET', signal }, options)
}

export const getAdminListBadgesQueryKey = () => {
  return [`/admin/badges`] as const
}

export const getAdminListBadgesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListBadges>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListBadgesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListBadges>>> = ({ signal }) =>
    adminListBadges(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListBadges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListBadgesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListBadges>>>
export type AdminListBadgesQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListBadges<
  TData = Awaited<ReturnType<typeof adminListBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListBadges>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListBadges>>,
          TError,
          Awaited<ReturnType<typeof adminListBadges>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListBadges<
  TData = Awaited<ReturnType<typeof adminListBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListBadges>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListBadges>>,
          TError,
          Awaited<ReturnType<typeof adminListBadges>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListBadges<
  TData = Awaited<ReturnType<typeof adminListBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListBadges>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список бейджей (админ)
 */

export function useAdminListBadges<
  TData = Awaited<ReturnType<typeof adminListBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListBadges>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListBadgesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Создать бейдж (админ)
 */
export const adminCreateBadge = (
  badgeCreateRequest: BadgeCreateRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Badge>(
    {
      url: `/admin/badges`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: badgeCreateRequest,
      signal,
    },
    options
  )
}

export const getAdminCreateBadgeMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateBadge>>,
    TError,
    { data: BadgeCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateBadge>>,
  TError,
  { data: BadgeCreateRequest },
  TContext
> => {
  const mutationKey = ['adminCreateBadge']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateBadge>>,
    { data: BadgeCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return adminCreateBadge(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminCreateBadgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateBadge>>
>
export type AdminCreateBadgeMutationBody = BadgeCreateRequest
export type AdminCreateBadgeMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | InternalErrorResponse

/**
 * @summary Создать бейдж (админ)
 */
export const useAdminCreateBadge = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateBadge>>,
      TError,
      { data: BadgeCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateBadge>>,
  TError,
  { data: BadgeCreateRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateBadgeMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить бейдж по ID (админ)
 */
export const adminGetBadge = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Badge>({ url: `/admin/badges/${id}`, method: 'GET', signal }, options)
}

export const getAdminGetBadgeQueryKey = (id?: string) => {
  return [`/admin/badges/${id}`] as const
}

export const getAdminGetBadgeQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetBadge>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBadge>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetBadgeQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetBadge>>> = ({ signal }) =>
    adminGetBadge(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetBadge>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetBadgeQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetBadge>>>
export type AdminGetBadgeQueryError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

export function useAdminGetBadge<
  TData = Awaited<ReturnType<typeof adminGetBadge>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBadge>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetBadge>>,
          TError,
          Awaited<ReturnType<typeof adminGetBadge>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetBadge<
  TData = Awaited<ReturnType<typeof adminGetBadge>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBadge>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetBadge>>,
          TError,
          Awaited<ReturnType<typeof adminGetBadge>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetBadge<
  TData = Awaited<ReturnType<typeof adminGetBadge>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBadge>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить бейдж по ID (админ)
 */

export function useAdminGetBadge<
  TData = Awaited<ReturnType<typeof adminGetBadge>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBadge>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetBadgeQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Мягкое удаление бейджа (установка deleted_at)
 */
export const adminSoftDeleteBadge = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/badges/${id}`, method: 'DELETE' }, options)
}

export const getAdminSoftDeleteBadgeMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSoftDeleteBadge>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSoftDeleteBadge>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSoftDeleteBadge']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSoftDeleteBadge>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminSoftDeleteBadge(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminSoftDeleteBadgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSoftDeleteBadge>>
>

export type AdminSoftDeleteBadgeMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Мягкое удаление бейджа (установка deleted_at)
 */
export const useAdminSoftDeleteBadge = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSoftDeleteBadge>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSoftDeleteBadge>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminSoftDeleteBadgeMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Обновить бейдж (админ)
 */
export const adminUpdateBadge = (
  id: string,
  badgeUpdateRequest: BadgeUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<Badge>(
    {
      url: `/admin/badges/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: badgeUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateBadgeMutationOptions = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateBadge>>,
    TError,
    { id: string; data: BadgeUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateBadge>>,
  TError,
  { id: string; data: BadgeUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateBadge']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateBadge>>,
    { id: string; data: BadgeUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateBadge(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateBadgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateBadge>>
>
export type AdminUpdateBadgeMutationBody = BadgeUpdateRequest
export type AdminUpdateBadgeMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Обновить бейдж (админ)
 */
export const useAdminUpdateBadge = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateBadge>>,
      TError,
      { id: string; data: BadgeUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateBadge>>,
  TError,
  { id: string; data: BadgeUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateBadgeMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список удаленных бейджей (админ)
 */
export const adminListDeletedBadges = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Badge[]>({ url: `/admin/badges/deleted`, method: 'GET', signal }, options)
}

export const getAdminListDeletedBadgesQueryKey = () => {
  return [`/admin/badges/deleted`] as const
}

export const getAdminListDeletedBadgesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDeletedBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedBadges>>, TError, TData>
  >
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListDeletedBadgesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDeletedBadges>>> = ({ signal }) =>
    adminListDeletedBadges(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDeletedBadges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListDeletedBadgesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDeletedBadges>>
>
export type AdminListDeletedBadgesQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListDeletedBadges<
  TData = Awaited<ReturnType<typeof adminListDeletedBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedBadges>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedBadges>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedBadges>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedBadges<
  TData = Awaited<ReturnType<typeof adminListDeletedBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedBadges>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedBadges>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedBadges>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedBadges<
  TData = Awaited<ReturnType<typeof adminListDeletedBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedBadges>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список удаленных бейджей (админ)
 */

export function useAdminListDeletedBadges<
  TData = Awaited<ReturnType<typeof adminListDeletedBadges>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedBadges>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListDeletedBadgesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Восстановить удаленный бейдж (админ)
 */
export const adminRestoreBadge = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Badge>(
    { url: `/admin/badges/${id}/restore`, method: 'POST', signal },
    options
  )
}

export const getAdminRestoreBadgeMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreBadge>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRestoreBadge>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRestoreBadge']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRestoreBadge>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminRestoreBadge(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRestoreBadgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRestoreBadge>>
>

export type AdminRestoreBadgeMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Восстановить удаленный бейдж (админ)
 */
export const useAdminRestoreBadge = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRestoreBadge>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminRestoreBadge>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminRestoreBadgeMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Полное удаление бейджа (админ)
 */
export const adminHardDeleteBadge = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/badges/${id}/hard-delete`, method: 'DELETE' }, options)
}

export const getAdminHardDeleteBadgeMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteBadge>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminHardDeleteBadge>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminHardDeleteBadge']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminHardDeleteBadge>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminHardDeleteBadge(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminHardDeleteBadgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminHardDeleteBadge>>
>

export type AdminHardDeleteBadgeMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Полное удаление бейджа (админ)
 */
export const useAdminHardDeleteBadge = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminHardDeleteBadge>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminHardDeleteBadge>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminHardDeleteBadgeMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список инфраструктуры (админ)
 */
export const adminListInfrastructures = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Infrastructure[]>(
    { url: `/admin/infrastructures`, method: 'GET', signal },
    options
  )
}

export const getAdminListInfrastructuresQueryKey = () => {
  return [`/admin/infrastructures`] as const
}

export const getAdminListInfrastructuresQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminListInfrastructures>>, TError, TData>
  >
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListInfrastructuresQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListInfrastructures>>> = ({
    signal,
  }) => adminListInfrastructures(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListInfrastructures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListInfrastructuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListInfrastructures>>
>
export type AdminListInfrastructuresQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListInfrastructures<
  TData = Awaited<ReturnType<typeof adminListInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListInfrastructures>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListInfrastructures>>,
          TError,
          Awaited<ReturnType<typeof adminListInfrastructures>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListInfrastructures<
  TData = Awaited<ReturnType<typeof adminListInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListInfrastructures>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListInfrastructures>>,
          TError,
          Awaited<ReturnType<typeof adminListInfrastructures>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListInfrastructures<
  TData = Awaited<ReturnType<typeof adminListInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListInfrastructures>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список инфраструктуры (админ)
 */

export function useAdminListInfrastructures<
  TData = Awaited<ReturnType<typeof adminListInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListInfrastructures>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListInfrastructuresQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Создать инфраструктуру (админ)
 */
export const adminCreateInfrastructure = (
  infrastructureCreateRequest: InfrastructureCreateRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Infrastructure>(
    {
      url: `/admin/infrastructures`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: infrastructureCreateRequest,
      signal,
    },
    options
  )
}

export const getAdminCreateInfrastructureMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateInfrastructure>>,
    TError,
    { data: InfrastructureCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateInfrastructure>>,
  TError,
  { data: InfrastructureCreateRequest },
  TContext
> => {
  const mutationKey = ['adminCreateInfrastructure']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateInfrastructure>>,
    { data: InfrastructureCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return adminCreateInfrastructure(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminCreateInfrastructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateInfrastructure>>
>
export type AdminCreateInfrastructureMutationBody = InfrastructureCreateRequest
export type AdminCreateInfrastructureMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | InternalErrorResponse

/**
 * @summary Создать инфраструктуру (админ)
 */
export const useAdminCreateInfrastructure = <
  TError = ValidationErrorResponse | UnauthorizedResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateInfrastructure>>,
      TError,
      { data: InfrastructureCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateInfrastructure>>,
  TError,
  { data: InfrastructureCreateRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateInfrastructureMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить инфраструктуру по ID (админ)
 */
export const adminGetInfrastructure = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Infrastructure>(
    { url: `/admin/infrastructures/${id}`, method: 'GET', signal },
    options
  )
}

export const getAdminGetInfrastructureQueryKey = (id?: string) => {
  return [`/admin/infrastructures/${id}`] as const
}

export const getAdminGetInfrastructureQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetInfrastructure>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetInfrastructure>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetInfrastructureQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetInfrastructure>>> = ({ signal }) =>
    adminGetInfrastructure(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInfrastructure>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetInfrastructureQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetInfrastructure>>
>
export type AdminGetInfrastructureQueryError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

export function useAdminGetInfrastructure<
  TData = Awaited<ReturnType<typeof adminGetInfrastructure>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetInfrastructure>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetInfrastructure>>,
          TError,
          Awaited<ReturnType<typeof adminGetInfrastructure>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetInfrastructure<
  TData = Awaited<ReturnType<typeof adminGetInfrastructure>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetInfrastructure>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetInfrastructure>>,
          TError,
          Awaited<ReturnType<typeof adminGetInfrastructure>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetInfrastructure<
  TData = Awaited<ReturnType<typeof adminGetInfrastructure>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetInfrastructure>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить инфраструктуру по ID (админ)
 */

export function useAdminGetInfrastructure<
  TData = Awaited<ReturnType<typeof adminGetInfrastructure>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetInfrastructure>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetInfrastructureQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Мягкое удаление инфраструктуры (установка deleted_at)
 */
export const adminSoftDeleteInfrastructure = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/infrastructures/${id}`, method: 'DELETE' }, options)
}

export const getAdminSoftDeleteInfrastructureMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSoftDeleteInfrastructure>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSoftDeleteInfrastructure>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSoftDeleteInfrastructure']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSoftDeleteInfrastructure>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminSoftDeleteInfrastructure(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminSoftDeleteInfrastructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSoftDeleteInfrastructure>>
>

export type AdminSoftDeleteInfrastructureMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Мягкое удаление инфраструктуры (установка deleted_at)
 */
export const useAdminSoftDeleteInfrastructure = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSoftDeleteInfrastructure>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSoftDeleteInfrastructure>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminSoftDeleteInfrastructureMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Обновить инфраструктуру (админ)
 */
export const adminUpdateInfrastructure = (
  id: string,
  infrastructureUpdateRequest: InfrastructureUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<Infrastructure>(
    {
      url: `/admin/infrastructures/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: infrastructureUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateInfrastructureMutationOptions = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateInfrastructure>>,
    TError,
    { id: string; data: InfrastructureUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateInfrastructure>>,
  TError,
  { id: string; data: InfrastructureUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateInfrastructure']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateInfrastructure>>,
    { id: string; data: InfrastructureUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateInfrastructure(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateInfrastructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateInfrastructure>>
>
export type AdminUpdateInfrastructureMutationBody = InfrastructureUpdateRequest
export type AdminUpdateInfrastructureMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Обновить инфраструктуру (админ)
 */
export const useAdminUpdateInfrastructure = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateInfrastructure>>,
      TError,
      { id: string; data: InfrastructureUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateInfrastructure>>,
  TError,
  { id: string; data: InfrastructureUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateInfrastructureMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить список удаленной инфраструктуры (админ)
 */
export const adminListDeletedInfrastructures = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Infrastructure[]>(
    { url: `/admin/infrastructures/deleted`, method: 'GET', signal },
    options
  )
}

export const getAdminListDeletedInfrastructuresQueryKey = () => {
  return [`/admin/infrastructures/deleted`] as const
}

export const getAdminListDeletedInfrastructuresQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDeletedInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedInfrastructures>>, TError, TData>
  >
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListDeletedInfrastructuresQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDeletedInfrastructures>>> = ({
    signal,
  }) => adminListDeletedInfrastructures(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDeletedInfrastructures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListDeletedInfrastructuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDeletedInfrastructures>>
>
export type AdminListDeletedInfrastructuresQueryError = UnauthorizedResponse | InternalErrorResponse

export function useAdminListDeletedInfrastructures<
  TData = Awaited<ReturnType<typeof adminListDeletedInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedInfrastructures>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedInfrastructures>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedInfrastructures>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedInfrastructures<
  TData = Awaited<ReturnType<typeof adminListDeletedInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedInfrastructures>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListDeletedInfrastructures>>,
          TError,
          Awaited<ReturnType<typeof adminListDeletedInfrastructures>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListDeletedInfrastructures<
  TData = Awaited<ReturnType<typeof adminListDeletedInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedInfrastructures>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить список удаленной инфраструктуры (админ)
 */

export function useAdminListDeletedInfrastructures<
  TData = Awaited<ReturnType<typeof adminListDeletedInfrastructures>>,
  TError = UnauthorizedResponse | InternalErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListDeletedInfrastructures>>, TError, TData>
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListDeletedInfrastructuresQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Восстановить удаленную инфраструктуру (админ)
 */
export const adminRestoreInfrastructure = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Infrastructure>(
    { url: `/admin/infrastructures/${id}/restore`, method: 'POST', signal },
    options
  )
}

export const getAdminRestoreInfrastructureMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreInfrastructure>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRestoreInfrastructure>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRestoreInfrastructure']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRestoreInfrastructure>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminRestoreInfrastructure(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRestoreInfrastructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRestoreInfrastructure>>
>

export type AdminRestoreInfrastructureMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Восстановить удаленную инфраструктуру (админ)
 */
export const useAdminRestoreInfrastructure = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRestoreInfrastructure>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminRestoreInfrastructure>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminRestoreInfrastructureMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Полное удаление инфраструктуры (админ)
 */
export const adminHardDeleteInfrastructure = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>(
    { url: `/admin/infrastructures/${id}/hard-delete`, method: 'DELETE' },
    options
  )
}

export const getAdminHardDeleteInfrastructureMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteInfrastructure>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminHardDeleteInfrastructure>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminHardDeleteInfrastructure']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminHardDeleteInfrastructure>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminHardDeleteInfrastructure(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminHardDeleteInfrastructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminHardDeleteInfrastructure>>
>

export type AdminHardDeleteInfrastructureMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Полное удаление инфраструктуры (админ)
 */
export const useAdminHardDeleteInfrastructure = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminHardDeleteInfrastructure>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminHardDeleteInfrastructure>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminHardDeleteInfrastructureMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Получить заявку по ID (админ)
 */
export const adminGetLead = (
  id: string,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<Lead>({ url: `/admin/leads/${id}`, method: 'GET', signal }, options)
}

export const getAdminGetLeadQueryKey = (id?: string) => {
  return [`/admin/leads/${id}`] as const
}

export const getAdminGetLeadQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetLead>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLead>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetLeadQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetLead>>> = ({ signal }) =>
    adminGetLead(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLead>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetLeadQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetLead>>>
export type AdminGetLeadQueryError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse

export function useAdminGetLead<
  TData = Awaited<ReturnType<typeof adminGetLead>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLead>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLead>>,
          TError,
          Awaited<ReturnType<typeof adminGetLead>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetLead<
  TData = Awaited<ReturnType<typeof adminGetLead>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLead>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLead>>,
          TError,
          Awaited<ReturnType<typeof adminGetLead>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetLead<
  TData = Awaited<ReturnType<typeof adminGetLead>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLead>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получить заявку по ID (админ)
 */

export function useAdminGetLead<
  TData = Awaited<ReturnType<typeof adminGetLead>>,
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLead>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetLeadQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Мягкое удаление заявки
 */
export const adminSoftDeleteLead = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<void>({ url: `/admin/leads/${id}`, method: 'DELETE' }, options)
}

export const getAdminSoftDeleteLeadMutationOptions = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSoftDeleteLead>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSoftDeleteLead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSoftDeleteLead']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSoftDeleteLead>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminSoftDeleteLead(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminSoftDeleteLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSoftDeleteLead>>
>

export type AdminSoftDeleteLeadMutationError =
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Мягкое удаление заявки
 */
export const useAdminSoftDeleteLead = <
  TError = UnauthorizedResponse | NotFoundResponse | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSoftDeleteLead>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSoftDeleteLead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminSoftDeleteLeadMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Обновить заявку (админ)
 */
export const adminUpdateLead = (
  id: string,
  leadUpdateRequest: LeadUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<Lead>(
    {
      url: `/admin/leads/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: leadUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateLeadMutationOptions = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateLead>>,
    TError,
    { id: string; data: LeadUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateLead>>,
  TError,
  { id: string; data: LeadUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateLead']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateLead>>,
    { id: string; data: LeadUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateLead(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateLead>>>
export type AdminUpdateLeadMutationBody = LeadUpdateRequest
export type AdminUpdateLeadMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalErrorResponse

/**
 * @summary Обновить заявку (админ)
 */
export const useAdminUpdateLead = <
  TError =
    | ValidationErrorResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateLead>>,
      TError,
      { id: string; data: LeadUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateLead>>,
  TError,
  { id: string; data: LeadUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateLeadMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Sign in with Microsoft (sets HttpOnly JWT cookie)
 */
export const adminAuthMicrosoft = (
  adminMicrosoftLoginRequest: AdminMicrosoftLoginRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<AdminAuthResponse>(
    {
      url: `/admin/auth/microsoft`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: adminMicrosoftLoginRequest,
      signal,
    },
    options
  )
}

export const getAdminAuthMicrosoftMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminAuthMicrosoft>>,
    TError,
    { data: AdminMicrosoftLoginRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminAuthMicrosoft>>,
  TError,
  { data: AdminMicrosoftLoginRequest },
  TContext
> => {
  const mutationKey = ['adminAuthMicrosoft']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminAuthMicrosoft>>,
    { data: AdminMicrosoftLoginRequest }
  > = props => {
    const { data } = props ?? {}

    return adminAuthMicrosoft(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminAuthMicrosoftMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminAuthMicrosoft>>
>
export type AdminAuthMicrosoftMutationBody = AdminMicrosoftLoginRequest
export type AdminAuthMicrosoftMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | ForbiddenResponse

/**
 * @summary Sign in with Microsoft (sets HttpOnly JWT cookie)
 */
export const useAdminAuthMicrosoft = <
  TError = ValidationErrorResponse | UnauthorizedResponse | ForbiddenResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminAuthMicrosoft>>,
      TError,
      { data: AdminMicrosoftLoginRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminAuthMicrosoft>>,
  TError,
  { data: AdminMicrosoftLoginRequest },
  TContext
> => {
  const mutationOptions = getAdminAuthMicrosoftMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Get current admin user info from JWT cookie
 */
export const adminAuthMe = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<AdminAuthResponse>({ url: `/admin/auth/me`, method: 'GET', signal }, options)
}

export const getAdminAuthMeQueryKey = () => {
  return [`/admin/auth/me`] as const
}

export const getAdminAuthMeQueryOptions = <
  TData = Awaited<ReturnType<typeof adminAuthMe>>,
  TError = UnauthorizedResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthMe>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminAuthMeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthMe>>> = ({ signal }) =>
    adminAuthMe(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminAuthMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthMe>>>
export type AdminAuthMeQueryError = UnauthorizedResponse

export function useAdminAuthMe<
  TData = Awaited<ReturnType<typeof adminAuthMe>>,
  TError = UnauthorizedResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthMe>>,
          TError,
          Awaited<ReturnType<typeof adminAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthMe<
  TData = Awaited<ReturnType<typeof adminAuthMe>>,
  TError = UnauthorizedResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthMe>>,
          TError,
          Awaited<ReturnType<typeof adminAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthMe<
  TData = Awaited<ReturnType<typeof adminAuthMe>>,
  TError = UnauthorizedResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current admin user info from JWT cookie
 */

export function useAdminAuthMe<
  TData = Awaited<ReturnType<typeof adminAuthMe>>,
  TError = UnauthorizedResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Logout (clears JWT cookie)
 */
export const adminAuthLogout = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<AdminAuthLogout200>(
    { url: `/admin/auth/logout`, method: 'POST', signal },
    options
  )
}

export const getAdminAuthLogoutMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminAuthLogout>>, TError, void, TContext>
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<Awaited<ReturnType<typeof adminAuthLogout>>, TError, void, TContext> => {
  const mutationKey = ['adminAuthLogout']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAuthLogout>>, void> = () => {
    return adminAuthLogout(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof adminAuthLogout>>>

export type AdminAuthLogoutMutationError = unknown

/**
 * @summary Logout (clears JWT cookie)
 */
export const useAdminAuthLogout = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminAuthLogout>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminAuthLogout>>, TError, void, TContext> => {
  const mutationOptions = getAdminAuthLogoutMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary List admin users (superadmin only)
 */
export const adminListTeam = (
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<AdminUser[]>({ url: `/admin/team`, method: 'GET', signal }, options)
}

export const getAdminListTeamQueryKey = () => {
  return [`/admin/team`] as const
}

export const getAdminListTeamQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListTeam>>,
  TError = UnauthorizedResponse | ForbiddenResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTeam>>, TError, TData>>
  request?: SecondParameter<typeof adminInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListTeamQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListTeam>>> = ({ signal }) =>
    adminListTeam(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListTeam>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListTeamQueryResult = NonNullable<Awaited<ReturnType<typeof adminListTeam>>>
export type AdminListTeamQueryError = UnauthorizedResponse | ForbiddenResponse

export function useAdminListTeam<
  TData = Awaited<ReturnType<typeof adminListTeam>>,
  TError = UnauthorizedResponse | ForbiddenResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTeam>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListTeam>>,
          TError,
          Awaited<ReturnType<typeof adminListTeam>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTeam<
  TData = Awaited<ReturnType<typeof adminListTeam>>,
  TError = UnauthorizedResponse | ForbiddenResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTeam>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListTeam>>,
          TError,
          Awaited<ReturnType<typeof adminListTeam>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTeam<
  TData = Awaited<ReturnType<typeof adminListTeam>>,
  TError = UnauthorizedResponse | ForbiddenResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTeam>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List admin users (superadmin only)
 */

export function useAdminListTeam<
  TData = Awaited<ReturnType<typeof adminListTeam>>,
  TError = UnauthorizedResponse | ForbiddenResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTeam>>, TError, TData>>
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListTeamQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Add admin user (superadmin only)
 */
export const adminAddTeamMember = (
  adminTeamMemberRequest: AdminTeamMemberRequest,
  options?: SecondParameter<typeof adminInstance>,
  signal?: AbortSignal
) => {
  return adminInstance<AdminUser>(
    {
      url: `/admin/team`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: adminTeamMemberRequest,
      signal,
    },
    options
  )
}

export const getAdminAddTeamMemberMutationOptions = <
  TError = ValidationErrorResponse | UnauthorizedResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminAddTeamMember>>,
    TError,
    { data: AdminTeamMemberRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminAddTeamMember>>,
  TError,
  { data: AdminTeamMemberRequest },
  TContext
> => {
  const mutationKey = ['adminAddTeamMember']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminAddTeamMember>>,
    { data: AdminTeamMemberRequest }
  > = props => {
    const { data } = props ?? {}

    return adminAddTeamMember(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminAddTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminAddTeamMember>>
>
export type AdminAddTeamMemberMutationBody = AdminTeamMemberRequest
export type AdminAddTeamMemberMutationError =
  | ValidationErrorResponse
  | UnauthorizedResponse
  | ForbiddenResponse

/**
 * @summary Add admin user (superadmin only)
 */
export const useAdminAddTeamMember = <
  TError = ValidationErrorResponse | UnauthorizedResponse | ForbiddenResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminAddTeamMember>>,
      TError,
      { data: AdminTeamMemberRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminAddTeamMember>>,
  TError,
  { data: AdminTeamMemberRequest },
  TContext
> => {
  const mutationOptions = getAdminAddTeamMemberMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Update admin user permissions (superadmin only)
 */
export const adminUpdateTeamMember = (
  id: string,
  adminTeamMemberUpdateRequest: AdminTeamMemberUpdateRequest,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<AdminUpdateTeamMember200>(
    {
      url: `/admin/team/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: adminTeamMemberUpdateRequest,
    },
    options
  )
}

export const getAdminUpdateTeamMemberMutationOptions = <
  TError = UnauthorizedResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateTeamMember>>,
    TError,
    { id: string; data: AdminTeamMemberUpdateRequest },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateTeamMember>>,
  TError,
  { id: string; data: AdminTeamMemberUpdateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateTeamMember']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateTeamMember>>,
    { id: string; data: AdminTeamMemberUpdateRequest }
  > = props => {
    const { id, data } = props ?? {}

    return adminUpdateTeamMember(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminUpdateTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateTeamMember>>
>
export type AdminUpdateTeamMemberMutationBody = AdminTeamMemberUpdateRequest
export type AdminUpdateTeamMemberMutationError = UnauthorizedResponse | ForbiddenResponse

/**
 * @summary Update admin user permissions (superadmin only)
 */
export const useAdminUpdateTeamMember = <
  TError = UnauthorizedResponse | ForbiddenResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateTeamMember>>,
      TError,
      { id: string; data: AdminTeamMemberUpdateRequest },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateTeamMember>>,
  TError,
  { id: string; data: AdminTeamMemberUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateTeamMemberMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}

/**
 * @summary Remove admin user (superadmin only)
 */
export const adminRemoveTeamMember = (
  id: string,
  options?: SecondParameter<typeof adminInstance>
) => {
  return adminInstance<AdminRemoveTeamMember200>(
    { url: `/admin/team/${id}`, method: 'DELETE' },
    options
  )
}

export const getAdminRemoveTeamMemberMutationOptions = <
  TError = UnauthorizedResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRemoveTeamMember>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof adminInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRemoveTeamMember>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRemoveTeamMember']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRemoveTeamMember>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return adminRemoveTeamMember(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRemoveTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRemoveTeamMember>>
>

export type AdminRemoveTeamMemberMutationError = UnauthorizedResponse | ForbiddenResponse

/**
 * @summary Remove admin user (superadmin only)
 */
export const useAdminRemoveTeamMember = <
  TError = UnauthorizedResponse | ForbiddenResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRemoveTeamMember>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof adminInstance>
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminRemoveTeamMember>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminRemoveTeamMemberMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
